// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1ZqCL","alert":"SettungsInbox_alert__29kjf"};